// @flow
import * as React from "react";
import { Box, Center, Text, Icon, HStack, Tooltip } from "@chakra-ui/react";
import { NavLink } from "react-router-dom";
import { NavNames, pathObject } from "../utils/paths";

import { SubNav } from "../utils/types";
import useHomeStore from "../useHomeStore";
import { useState } from "react";
import { useGetOrderMediaConfig } from "../views/PlaceOrderTest/queryHooks";

const Index = () => {
  const secret = "33333333";
  const [keyPressed, setKeyPressed] = useState<any[]>([]);
  const [timeoutId, setTimeoutId] = useState<any>(null);
  const setIsCarsIconVisible = useHomeStore(
    (state) => state.setIsCarsIconVisible,
  );
  React.useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      const newKeysPressed = [...keyPressed, event.key];
      if (newKeysPressed.join("") === secret) {
        setIsCarsIconVisible(true);
      }
      setKeyPressed(newKeysPressed);
      clearTimeout(timeoutId);
      const newTimeoutId = setTimeout(() => {
        setKeyPressed([]);
      }, 3000);
      setTimeoutId(newTimeoutId);
    };
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
      clearTimeout(timeoutId);
    };
  }, [keyPressed]);

  const navs = pathObject
    .reduce((prevVal: SubNav[], currVal) => {
      return [...prevVal, ...currVal.sub];
    }, [])
    .map((item) => <NavIcon {...item} key={item.path + item.name} />);

  return (
    <HStack
      bg="transparent"
      height="100%"
      borderColor="gray.200"
      alignItems="center"
      gap={3}
      spacing={0}
    >
      {navs}
    </HStack>
  );
};

const NavIcon = ({ path, icon, name }: SubNav) => {
  const isCarsIconVisible = useHomeStore((state) => state.isCarsIconVisible);
  const { data: mobileConfigs, isLoading } = useGetOrderMediaConfig();

  const isPartMaster = name === NavNames.partMaster;
  const isPaymentLinks = name === NavNames.PaymentLinks;
  const partMasterUrl = mobileConfigs?.zoho_creator_part_master_application;
  const paymentLinksUrl =
    mobileConfigs?.zoho_creator_customer_payment_links_application;
  const isPartMasterDisabled = isPartMaster && (isLoading || !partMasterUrl);

  if (name === NavNames.cars && !isCarsIconVisible) {
    return null;
  }

  const handleClick = (e: React.MouseEvent) => {
    if (isPartMaster) {
      e.preventDefault();
      if (!isPartMasterDisabled) {
        window.open(partMasterUrl, "_blank");
      }
    } else if (isPaymentLinks) {
      e.preventDefault();
      window.open(paymentLinksUrl, "_blank");
    }
  };

  return (
    <Center>
      <Tooltip label={name} placement="bottom" hasArrow openDelay={300}>
        <Box as="span" display="block" lineHeight={0}>
          <NavLink to={path} style={{ width: "100%" }} onClick={handleClick}>
            {({ isActive }) => {
              const activeColor =
                isActive && !isPartMaster && !isPaymentLinks
                  ? "#0A2546"
                  : "white";

              return (
                <Text
                  as="span"
                  display="inline-flex"
                  alignItems="center"
                  justifyContent="center"
                  fontSize="md"
                  color={activeColor}
                  fontWeight={isActive ? "semibold" : "bold"}
                  opacity={isPartMasterDisabled ? 0.5 : 1}
                  cursor={isPartMasterDisabled ? "not-allowed" : "pointer"}
                  p={2}
                  borderRadius="md"
                  _hover={{
                    opacity: isPartMasterDisabled ? 0.5 : 1,
                  }}
                  transition="color 0.15s, opacity 0.15s"
                  aria-label={name}
                >
                  <Icon as={icon} boxSize={5} />
                </Text>
              );
            }}
          </NavLink>
        </Box>
      </Tooltip>
    </Center>
  );
};

export default Index;
